import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["dataIndex", "render", "fieldType", "linkConfig", "fontColor", "bgColor"];
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.fixed.js";
import "core-js/modules/es6.object.to-string.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import objectPath from 'object-path';
import i18n from './lib/i18n';
import { getComponentLocale } from '../../wui-locale/src/tool';
import { formatMoney } from './lib/utils';
import Dropdown from '../../wui-dropdown/src';
import Menu from '../../wui-menu/src';
import { prefix } from "../../wui-core/src/index.js";
var Item = Menu.Item;
var propTypes = {
  record: PropTypes.object,
  clsPrefix: PropTypes.string,
  index: PropTypes.number,
  indent: PropTypes.number,
  indentSize: PropTypes.number,
  column: PropTypes.object,
  expandIcon: PropTypes.node,
  onPaste: PropTypes.func
};

var TableCell = /*#__PURE__*/function (_Component) {
  _inherits(TableCell, _Component);

  var _super = _createSuper(TableCell);

  function TableCell(props) {
    var _this;

    _classCallCheck(this, TableCell);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderLinkType", function (data, record, index) {
      var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var url = config.url,
          urlIndex = config.urlIndex,
          linkType = config.linkType,
          className = config.className,
          underline = config.underline,
          descIndex = config.descIndex,
          desc = config.desc,
          linkColor = config.linkColor;
      var linkUrl = '';

      if (url) {
        linkUrl = url(data, record, index);
      } else if (urlIndex) {
        linkUrl = record[urlIndex];
      }

      if (linkUrl) {
        var link = function link() {
          window.open(linkUrl, linkType || '_blank');
        };

        var cls = "".concat(prefix, "-table-link ").concat(prefix, "-table-fieldtype ");

        if (className) {
          cls += "".concat(className, " ");
        }

        if (underline) {
          cls += "".concat(prefix, "-table-link-underline ");
        }

        var title = '';

        if (desc === true) {
          title = linkUrl;
        } else if (typeof desc === 'string') {
          title = desc;
        } else if (typeof desc === 'function') {
          title = desc(data, record, index);
        } else if (descIndex) {
          title = record[descIndex];
        }

        return /*#__PURE__*/React.createElement("span", {
          onClick: link,
          className: cls,
          style: {
            color: linkColor || ''
          },
          title: title
        }, data);
      }

      return data;
    });

    _defineProperty(_assertThisInitialized(_this), "renderBoolType", function (data) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var locale = getComponentLocale(_this.props, _this.context, 'Table', function () {
        return i18n;
      });

      var boolConfig = _objectSpread(_objectSpread({}, {
        trueText: locale['bool_true'],
        falseText: locale['bool_false']
      }), config);

      if (typeof data === 'string') {
        if (data === 'false' || data === '0') {
          return boolConfig.falseText;
        }
      } else if (!data) {
        return boolConfig.falseText;
      }

      return boolConfig.trueText;
    });

    _defineProperty(_assertThisInitialized(_this), "renderNumber", function (data) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
      var precision = config.precision,
          thousand = config.thousand,
          makeUp = config.makeUp,
          preSymbol = config.preSymbol,
          nextSymbol = config.nextSymbol;
      var number = formatMoney(data, precision, thousand);

      if (makeUp === false && number.indexOf('.') !== -1) {
        number = number.replace(/0*$/, '').replace(/\.$/, '');
      }

      var numberWidth = parseInt(width) - 16; // 减去默认的左右padding共计16px

      var res = /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-table-currency-number")
      }, number);
      var pre = preSymbol ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-table-currency-pre")
      }, preSymbol) : null;
      var next = nextSymbol ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-table-currency-next")
      }, nextSymbol) : null;
      var title = '';
      title += typeof preSymbol === 'string' ? preSymbol : '';
      title += number;
      title += typeof nextSymbol === 'string' ? nextSymbol : '';
      return /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-table-currency ").concat(prefix, "-table-fieldtype"),
        style: {
          width: numberWidth
        },
        title: title
      }, pre, res, next);
    });

    _defineProperty(_assertThisInitialized(_this), "renderDate", function (data) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var moment = config.moment,
          format = config.format;
      if (!moment) return data;
      return moment(data).format(format || 'YYYY-MM-DD');
    });

    _defineProperty(_assertThisInitialized(_this), "renderSelect", function (data) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (config.options) {
        data = config.options[data] || config.defaultShow;
      }

      return data;
    });

    _defineProperty(_assertThisInitialized(_this), "renderColumnMenu", function (colMenu, text, record, index) {
      if (!colMenu) return null;
      var menu = colMenu.menu,
          _colMenu$trigger = colMenu.trigger,
          trigger = _colMenu$trigger === void 0 ? 'hover' : _colMenu$trigger,
          _colMenu$className = colMenu.className,
          className = _colMenu$className === void 0 ? '' : _colMenu$className,
          _colMenu$icon = colMenu.icon,
          icon = _colMenu$icon === void 0 ? /*#__PURE__*/React.createElement("i", {
        className: "uf uf-3dot-h"
      }) : _colMenu$icon,
          _colMenu$iconSize = colMenu.iconSize,
          iconSize = _colMenu$iconSize === void 0 ? 21 : _colMenu$iconSize;
      var items = [];
      items = menu.map(function (item) {
        return /*#__PURE__*/React.createElement(Item, {
          key: item.key,
          onClick: function onClick() {
            _this.onClickColMenu(item.callback, text, record, index);
          }
        }, item.icon, item.text);
      });
      if (items.length === 0) return null;
      className += " ".concat(prefix, "-table-inline-op-dropdowm");
      var menus = /*#__PURE__*/React.createElement(Menu, {
        className: className
      }, items);
      var top = "calc(50% - ".concat(iconSize / 2, "px)");
      var visibility = _this.state.showDropdowm ? 'visible' : '';
      var iconClassName = "".concat(prefix, "-table-inline-op-icon ").concat(prefix, "-table-inline-op-icon-hover");
      return /*#__PURE__*/React.createElement(Dropdown, {
        trigger: [trigger],
        overlay: menus,
        animation: "slide-up",
        onVisibleChange: _this.changeShowDropdowm
      }, /*#__PURE__*/React.createElement("span", {
        className: iconClassName,
        style: {
          fontSize: iconSize,
          top: top,
          visibility: visibility
        }
      }, icon));
    });

    _defineProperty(_assertThisInitialized(_this), "changeShowDropdowm", function (val) {
      _this.setState({
        showDropdowm: val
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClickColMenu", function (callback, text, record, index) {
      if (callback) {
        callback(text, record, index);
      }

      _this.setState({
        showDropdowm: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPaste", function (e) {
      var _this$props = _this.props,
          row = _this$props.index,
          onPaste = _this$props.onPaste,
          fixed = _this$props.fixed,
          col = _this$props.col;
      var position = {
        row: row,
        col: col,
        fixed: !!fixed
      };
      onPaste(e, position);
    });

    _defineProperty(_assertThisInitialized(_this), "onCellMouseOver", function (e) {
      var column = _this.props.column;

      _this.props.stopRowDrag(column.notRowDrag);
    });

    _this.isInvalidRenderCellText = _this.isInvalidRenderCellText.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.state = {
      showDropdowm: false
    };
    return _this;
  }

  _createClass(TableCell, [{
    key: "isInvalidRenderCellText",
    value: function isInvalidRenderCellText(text) {
      return text && ! /*#__PURE__*/React.isValidElement(text) && Object.prototype.toString.call(text) === '[object Object]';
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var _this$props2 = this.props,
          record = _this$props2.record,
          onCellClick = _this$props2.column.onCellClick;

      if (onCellClick) {
        onCellClick(record, e);
      }
    } //  渲染链接类型

  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          record = _this$props3.record,
          indentSize = _this$props3.indentSize,
          clsPrefix = _this$props3.clsPrefix,
          indent = _this$props3.indent,
          index = _this$props3.index,
          expandIcon = _this$props3.expandIcon,
          column = _this$props3.column,
          fixed = _this$props3.fixed,
          showSum = _this$props3.showSum,
          bodyDisplayInRow = _this$props3.bodyDisplayInRow,
          lazyStartIndex = _this$props3.lazyStartIndex,
          lazyEndIndex = _this$props3.lazyEndIndex,
          getCellClassName = _this$props3.getCellClassName;

      var dataIndex = column.dataIndex,
          render = column.render,
          fieldType = column.fieldType,
          linkConfig = column.linkConfig,
          fontColor = column.fontColor,
          bgColor = column.bgColor,
          other = _objectWithoutProperties(column, _excluded);

      var _column$className = column.className,
          className = _column$className === void 0 ? '' : _column$className;
      var text = objectPath.get(record, dataIndex);
      var tdProps;
      var colSpan;
      var rowSpan, title;
      var colMenu = this.renderColumnMenu(column.cellMenu, text, record, index); // 如果是固定列在主表格上就渲染null

      if (column.fixed && !fixed) {
        text = null;
      } else {
        if (render && !showSum) {
          text = render(text, record, index, _objectSpread({
            dataIndex: dataIndex,
            render: render,
            fieldType: fieldType,
            linkConfig: linkConfig,
            fontColor: fontColor,
            bgColor: bgColor
          }, other));

          if (this.isInvalidRenderCellText(text)) {
            tdProps = text.props || {};
            rowSpan = tdProps.rowSpan > lazyEndIndex && lazyEndIndex > 5 ? lazyEndIndex - index : tdProps.rowSpan;
            colSpan = tdProps.colSpan;
            text = text.children;
          }
        } // 根据 fieldType 来渲染数据


        if (!render) {
          switch (column.fieldType) {
            case 'link':
              {
                text = this.renderLinkType(text, record, index, column.linkConfig);
                break;
              }

            case 'bool':
              {
                text = this.renderBoolType(text, column.boolConfig);
                break;
              }

            case 'currency':
              {
                var config = {
                  precision: 2,
                  // 精度值,需要大于0
                  thousand: true,
                  // 是否显示千分符号
                  makeUp: true,
                  // 末位是否补零
                  preSymbol: '',
                  // 前置符号
                  nextSymbol: '' // 后置符号

                };
                text = this.renderNumber(text, _objectSpread(_objectSpread({}, config), column.currencyConfig), column.width);
                break;
              }

            case 'number':
              {
                var _config = {
                  precision: 0,
                  // 精度值,需要大于0
                  thousand: true,
                  // 是否显示千分符号
                  makeUp: false,
                  // 末位是否补零
                  preSymbol: '',
                  // 前置符号
                  nextSymbol: '' // 后置符号

                };
                text = this.renderNumber(text, _objectSpread(_objectSpread({}, _config), column.numberConfig), column.width);
                break;
              }

            case 'date':
              {
                text = this.renderDate(text, column.dateConfig);
                break;
              }

            case 'select':
              {
                text = this.renderSelect(text, column.selectConfig);
                break;
              }

            default:
              {
                break;
              }
          }
        }
      }

      if (this.isInvalidRenderCellText(text)) {
        text = null;
      }

      var indentText = expandIcon ? /*#__PURE__*/React.createElement("span", {
        style: {
          paddingLeft: "".concat(indentSize * indent, "px")
        },
        className: "".concat(clsPrefix, "-indent indent-level-").concat(indent)
      }) : null;

      if (lazyStartIndex !== index && (rowSpan === 0 || colSpan === 0)) {
        return null;
      }

      if (tdProps && tdProps.mergeEndIndex && index < tdProps.mergeEndIndex && rowSpan === 0) {
        rowSpan = tdProps.mergeEndIndex - index;
        text = '';
      } //注意：中间表格区域不需要渲染出固定列的单元格，以节省多余的性能消耗


      if (!fixed && column.fixed) return null;

      if (column.contentAlign) {
        className = className + " text-".concat(column.contentAlign);
      } else if (column.textAlign) {
        className = className + " text-".concat(column.textAlign);
      }

      if ((typeof text == 'string' || typeof text === 'number') && bodyDisplayInRow) {
        title = text;
      }

      if (expandIcon && expandIcon.props.expandable) {
        className = className + " ".concat(clsPrefix, "-has-expandIcon");
      }

      if (colMenu) {
        className += " ".concat(prefix, "-table-inline-icon");
      }

      if (typeof getCellClassName == 'function') {
        var selfClassName = getCellClassName(record, index, column) || '';
        className += " ".concat(selfClassName);
      }

      if (colSpan == 0) return null;
      return /*#__PURE__*/React.createElement("td", {
        draggable: column.draggable,
        colSpan: colSpan,
        rowSpan: rowSpan,
        className: className,
        onClick: this.handleClick,
        title: title,
        onPaste: this.onPaste,
        onMouseOver: this.onCellMouseOver,
        style: _objectSpread({
          maxWidth: column.width,
          color: fontColor,
          backgroundColor: bgColor
        }, column.style)
      }, indentText, expandIcon, text, colMenu);
    }
  }]);

  return TableCell;
}(Component);

;
TableCell.propTypes = propTypes;
export default TableCell;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/TableCell.js